export const classSize = {
  sm: "small-screen",
  lg: "large-screen",
};

export const PLAYBACK_TYPE = {
  max: 1,
  shop: 2,
  lite: 3,
  social: 4,
  ctv: 5,
  maxo3: 6,
  tiktok: 7,
};

export const PLAYER_SIZES = {
  'Extra Small': { horizontal: 320, vertical: 480, key:'1', class:'xsm' },
  'Small': { horizontal: 500, vertical: 640, key:'2', class:'sm' },
  'Medium': { horizontal: 800, vertical: 800, key:'3', class:'md' },
  'Large': { horizontal: 1200, vertical: 960, key:'4', class:'lg' },
  'Fullscreen': { horizontal: 0, vertical: 0, key:'5', class:'xlg' },
};

export const CREATIVE_PARAMS_BANNER = {
  0: {
    active: false,
    size: {
      width: 300,
      height: 250,
    },
  },
  1: {
    active: true,
    size: {
      width: 300,
      height: 250,
    },
  },
  2: {
    active: true,
    size: {
      width: 300,
      height: 600,
    },
  },
  3: {
    active: true,
    size: {
      width: 970,
      height: 250,
    },
  },
};

export const CREATIVE_PARAMS_MOBILE_VIEW = {
  0: false,
  1: true,
};

export const CREATIVE_PARAMS_PLAYER_SIZE = {
  0: 'xsm',
  1: 'sm',
  2: 'md',
  3: 'lg',
  4: 'xlg',
};

export const VIDEO_CONTROLS_HEIGHT = 30;
